/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InvoicesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List invoices
     * Returns a paginated list of invoices, optionally filtered by society or client.
     * @returns any Paginated list of invoices.
     * @throws ApiError
     */
    public invoicesControllerFindAll({
        societyId,
        clientId,
        type,
        page,
        limit,
    }: {
        /**
         * Filter by society
         */
        societyId?: string,
        /**
         * Filter by client
         */
        clientId?: string,
        /**
         * Filter by invoice type
         */
        type?: 'CLIENT' | 'SOCIETY',
        /**
         * Page number (1-based)
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/invoices',
            query: {
                'societyId': societyId,
                'clientId': clientId,
                'type': type,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Get invoice by intervention ID
     * Returns the invoice associated with a specific intervention.
     * @returns any Invoice found.
     * @throws ApiError
     */
    public invoicesControllerFindByIntervention({
        interventionId,
    }: {
        /**
         * Intervention ID
         */
        interventionId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/invoices/intervention/{interventionId}',
            path: {
                'interventionId': interventionId,
            },
            errors: {
                404: `No invoice for this intervention.`,
            },
        });
    }
    /**
     * Get invoice by ID
     * Returns a single invoice by its unique identifier.
     * @returns any Invoice found.
     * @throws ApiError
     */
    public invoicesControllerFindOne({
        id,
    }: {
        /**
         * Invoice ID
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/invoices/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Invoice not found.`,
            },
        });
    }
    /**
     * Get signed PDF download URL
     * Returns a time-limited Firebase Storage signed URL (60 min) for downloading the invoice PDF.
     * @returns any Signed URL for PDF download.
     * @throws ApiError
     */
    public invoicesControllerGetPdfUrl({
        id,
    }: {
        /**
         * Invoice ID
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/invoices/{id}/pdf-url',
            path: {
                'id': id,
            },
            errors: {
                404: `Invoice not found or PDF not yet generated.`,
            },
        });
    }
}
